import { IModel, Model } from './Model';

export interface IHospitalPrescriptionRequestSourceModel extends IModel {
  hospitalPrescriptionRequestSourceId: number;
  name: string;
  isDeleted: boolean;
}

export class HospitalPrescriptionRequestSourceModel
  extends Model
  implements IHospitalPrescriptionRequestSourceModel
{
  hospitalPrescriptionRequestSourceId: number;
  name: string;
  isDeleted: boolean;

  constructor(params: Partial<IHospitalPrescriptionRequestSourceModel>) {
    super(params);
    this.hospitalPrescriptionRequestSourceId = _.defaultTo(
      params.hospitalPrescriptionRequestSourceId,
      0,
    );
    this.name = _.defaultTo(params.name, '');
    this.isDeleted = _.defaultTo(params.isDeleted, false);
  }
}
